import { PreAccessOverviewTab } from "../components";
import Overview from "../Overview";
import { useOverviewTabWithPreAccess } from "./useOverviewTabWithPreAccess";

const OverviewTabWithPreAccess = (): JSX.Element => {
  const { isPreAccess } = useOverviewTabWithPreAccess();

  if (isPreAccess) {
    return <PreAccessOverviewTab />;
  }

  return <Overview />;
};

export default OverviewTabWithPreAccess;
